"use client"

import FormTextInput from "@/shared/components/form-inputs/form-text-input"
import FormPhoneInput from "@/shared/components/form-inputs/form-phone-input"
import FormSelectInput from "../../../../../shared/components/form-inputs/form-select-input"
import { servingPreferenceOptions } from "@/features/auth/constants/select-options"
import FormTextareaInput from "../../../../../shared/components/form-inputs/form-textarea-input"
import { SignupFormType } from "@/features/auth/types/signup.type"
import { useFormContext } from "react-hook-form"
import { RegisterStateCountryAutocomplete } from "@/shared/components/form-inputs/RegisterStateCountryAutocomplete"
import { useState } from "react"
  

// TODO: Remove this phone number, only for phone number testing
// 877-406-6154
// +18774066154
// '+18786786877'
function SignupForm1({ selectedRole }: { selectedRole?: 'volunteer' | 'homeowner' | null }) {
    const { control } = useFormContext<SignupFormType>()
    const [locationDetails, setLocationDetails] = useState<any | null>(null)
    
    return (
        <div className="flex flex-col gap-1.5">
            <FormTextInput
                placeholder="Full Name*"
                name="form1.fullname"
                inputGroupProps={{
                    label: "Full Name *",
                }}
                control={control}
                autoComplete="name"
            />
            <FormPhoneInput
                placeholder="Phone Number*"
                name="form1.phone"
                inputGroupProps={{
                    label: "Phone Number *",
                }}
                control={control}
                autoComplete="tel"
            />
            <FormTextInput
                placeholder="Email*"
                name="form1.email"
                type="email"
                inputGroupProps={{
                    label: "Email *",
                }}
                control={control}
                autoComplete="email"
            />
            {/* Both volunteers and homeowners use OTP login; passwords deprecated for new accounts */}
            
            {/* Show address fields for homeowners */}
            {selectedRole === 'homeowner' && (
                <div className="pt-4 space-y-4">
                    <h3 className="text-lg font-semibold">Home Address</h3>
                    <RegisterStateCountryAutocomplete
                        setLocationDetails={setLocationDetails}
                        locationDetails={locationDetails}
                        control={control}
                        fieldPrefix="form1"
                    />
                </div>
            )}
        </div>

    )
}

export default SignupForm1